
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 67 72","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 71.082h66.269V.302H0z"}})]),_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M49.35 5.155l12.145 12.348H49.349V5.155zm14.1 63.107H28.2v-8.46h-1.41a7.058 7.058 0 01-7.05-7.05l.003-.08-.001-.066c-.031-2.229.798-4.566 2.465-6.948a9.716 9.716 0 001.763-5.595c0-4.673-3.32-8.74-7.895-9.668l-.565-.114V3.12h31.02v17.202h16.92v47.94zm-60.63 0h22.56v-5.64H2.82v5.64zM9.3 58.674a9.773 9.773 0 001.979-5.897c-.002-.043-.002-.093-.001-.166.017-1.798-.307-5.25-2.674-8.17-1.408-1.736-1.883-3.926-1.336-6.165.616-2.517 2.741-4.567 5.29-5.1 2.144-.45 4.324.063 5.98 1.408a7.029 7.029 0 012.61 5.479 6.91 6.91 0 01-1.252 3.978c-2.727 3.896-2.99 7.317-2.977 8.607v.129a9.771 9.771 0 001.979 5.897l.85 1.128H8.451l.849-1.128zM12.69.3v29.974l-.632.125-.08.015c-3.586.752-6.58 3.642-7.448 7.19-.75 3.07-.064 6.21 1.884 8.613 1.924 2.372 2.053 5.577 2.046 6.51v.025a7.058 7.058 0 01-7.05 7.05H0v11.28h66.269V18.335L48.529.3H12.69z","fill":"#4788C6"}}),_c('path',{attrs:{"d":"M45.824 59.802c-5.053 0-9.164-4.11-9.164-9.165 0-5.053 4.11-9.164 9.164-9.164 5.054 0 9.165 4.111 9.165 9.164 0 5.054-4.111 9.165-9.165 9.165m0-21.15c-6.608 0-11.984 5.377-11.984 11.985 0 6.609 5.376 11.986 11.984 11.986 6.609 0 11.985-5.377 11.985-11.986 0-6.608-5.376-11.984-11.985-11.984","fill":"#4788C6"}}),_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"mask":"url(#b)","d":"M21.15 16.093h19.74v-2.82H21.15zM21.15 24.553h19.74v-2.82H21.15zM29.61 33.013h28.2v-2.82h-28.2z"}})])])
          )
        }
      }
    